import { Type } from 'class-transformer';

export enum ExitCategoryTypes {
	Deceased = '1',
	GraduatedCompleted = '4',
	Transferred = '7',
	IncarceratedInstitutionalized = '10',
	Eligibility = '13',
	StudentInitiatedWithdrawal = '16',
	LackOfProgressDrop = '19',
	LackOfAttendance = '22',
	Moved = '25',
	EnrollmentError = '28',
	StudentChangedPortal = '31',
	Health = '34',
	GraduationError = '35',
	Other = 'null',
}

export enum ExitReasons {
	InDistrictTransfer = '2',
	StateTesting = '152',
	StudentChangedPortal = '154',
	GraduationError = '158',
}

export class ExitReasonModel {
	@Type(ExitReasonCategoryModel_ClassTransformType)
	exit_reasons: ExitReasonCategoryModel[];
}

export class ExitReasonCategoryModel {
	exit_category_id: ExitCategoryTypes;
	exit_category_name: string;
	exit_reason_id: string | ExitReasons;
	exit_reason_name: string;
	show_calendar: boolean;
}

export function ExitReasonCategoryModel_ClassTransformType() {
	return ExitReasonCategoryModel;
}
